import { Injectable } from "@angular/core";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { HttpService } from "src/app/shared/http.service";
import { InsertBuilding } from "../models/InsertBuilding";
import { ImportType } from "../models/ImportType.enum";
import { InsertAddress } from "../models/insertAddress";

@Injectable()
export class LomImportService {
  constructor(private readonly httpService: HttpService) {}

  getImportTitleText(type: ImportType): string {
    switch (type) {
      case ImportType.building:
        return "Building Keys (BID)";
      case ImportType.address:
        return "Address Keys (GAID)";
      default:
        return "Values";
    }
  }

  getImportDetailText(type: ImportType): string {
    switch (type) {
      case ImportType.building:
        return "Enter your building LOM keys here separated by Comma ( , )";
      case ImportType.address:
        return "Enter your address LOM keys here separated by Comma ( , )";
      default:
        return "";
    }
  }

  executeBuildingLomImport(data: InsertBuilding) {
    return this.httpService.post(APIEndpoints.lomImportBuilding, data, true);
  }

  executeAddressLomImport(data: InsertAddress) {
    return this.httpService.post(APIEndpoints.lomImportAddress, data, true);
  }
}
